import { createFileRoute } from "@tanstack/react-router"
import { ConfigureTopups } from "modules/subscription/components/Usage/ConfigureTopups"

export const Route = createFileRoute("/_base/_auth/settings/subscription/usage/configure-topups")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  function onClose() {
    navigate({ to: "/settings/subscription/usage", search })
  }

  return <ConfigureTopups onClose={onClose} />
}
